/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PartialDataMappingFromJSON, PartialDataMappingToJSON, } from './';
export function UpdateDataMappingRequestFromJSON(json) {
    return UpdateDataMappingRequestFromJSONTyped(json, false);
}
export function UpdateDataMappingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        dataMapping: !exists(json, 'dataMapping') ? undefined : PartialDataMappingFromJSON(json['dataMapping']),
    };
}
export function UpdateDataMappingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        dataMapping: PartialDataMappingToJSON(value.dataMapping),
    };
}
